import type { Dispatch, SetStateAction } from 'react';
import type { ClaudiStickerId } from '../../../domain';
import type { ArrowDirection } from '../components/atomic/buttons/arrows/Arrows';
import type { NavBarTab } from '../components/composite/nav/nav_bar/NavBar';
import type { InfoPopupState } from '../shared/infoPopup/infoPopupState';
import {
  createVerticalArrowPositions,
  FIGMA_VERTICAL_ARROW_SCALE,
} from '../shared/verticalArrows/verticalArrows';

export const STICKERS_ARROW_SCALE = FIGMA_VERTICAL_ARROW_SCALE;
export const STICKERS_ARROW_POSITIONS = createVerticalArrowPositions(330);

export const MAX_STICKER_PAGE = 2;

export type StickersScreenProps = {
  activeTab?: NavBarTab;
  isStickerUnlocked?: (id: ClaudiStickerId) => boolean;
  onInfoClick?: () => void;
  onNavigate?: (direction: ArrowDirection) => void;
  onTabChange?: (tab: NavBarTab) => void;
};

export type StickersScreenState = InfoPopupState & {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
};

export type StickersScreenModel = {
  infoOpen: boolean;
  setInfoOpen: Dispatch<SetStateAction<boolean>>;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  activeTab: NavBarTab;
  isStickerUnlocked: (id: ClaudiStickerId) => boolean;
  onInfoClick?: () => void;
  onNavigate?: (direction: ArrowDirection) => void;
  onTabChange?: (tab: NavBarTab) => void;
};

export function createStickersScreenModel(
  props: StickersScreenProps,
  state: StickersScreenState,
): StickersScreenModel {
  return {
    infoOpen: state.infoOpen,
    setInfoOpen: state.setInfoOpen,
    page: state.page,
    setPage: state.setPage,
    activeTab: props.activeTab ?? 'rewards',
    isStickerUnlocked: props.isStickerUnlocked ?? (() => false),
    onInfoClick: props.onInfoClick,
    onNavigate: props.onNavigate,
    onTabChange: props.onTabChange,
  };
}
